//import React, { useEffect } from 'react'
//import logo from './components/1_LeftMenuSection/Parts/images/kclogo.png';
import '../../App.css';
import Spinner from '../content/Spinner';
//import CheckToken from './components/myFunctions/index';
//import errorMessageBox from '../content/errorMessageBox';
//import LeftMenuArea from '../1_LeftMenuSection/LeftMenuArea';
//import HomeLogoSection from '../1_LeftMenuSection/LogoSection/HomeLogoSection';
//import MenuSection from '../1_LeftMenuSection/MenuSection/MenuSection';
//import HomeMenuSection from '../1_LeftMenuSection/MenuSection/Parts/1_HomeMenuSection';
//import ShortcutMenuSection from '../1_LeftMenuSection/MenuSection/Parts/2_ShortcutMenuSection';
//import ProductsMenuSection from '../1_LeftMenuSection/MenuSection/Parts/3_ProductsMenuSection';
import MiddleSection from '../2_MiddleSection/MiddleSection';
import ContentContainer from '../2_MiddleSection/Parts/ContentContainer/ContentContainer';
import SearchBarMenuItems from '../2_MiddleSection/Parts/ContentContainer/Parts/SearchBarMenuItems/SearchBarMenuItems';
//import MessageBoxActionBtn from '../2_MiddleSection/Parts/ContentContainer/Parts/MessageBoxActionBtn/MessageBoxActionBtn';
//import SummaryCards from '../2_MiddleSection/Parts/ContentContainer/Parts/SummaryCards/SummaryCards';
//import TableSortingMenuActionBtn from '../2_MiddleSection/Parts/ContentContainer/Parts/TableSortingMenuActionBtn/TableSortingMenuActionBtn';
import TableOne from '../2_MiddleSection/Parts/ContentContainer/Parts/TableOne/TableOne';
import TableFooter from '../2_MiddleSection/Parts/ContentContainer/Parts/TableFooter/TableFooter';
//import RightAddSection from '../3_RightAddSection/RightAddSection';
import TableOneEditModal from "../content/TableOneEditModal";

//import Login from '../pages/Login';

import { useState, useRef } from 'react'

const Home = (props) => {
  //const [user, setUser] = useState();
  const [spinner, setSpinner] = useState(false);
  const [showTableOneModal, setShowTableOneModal] = useState(false);
  const [tableOneEvent, setTableOneEvent] = useState({});
  //const [tableOneRefresh, setTableOneRefresh] = useState();
  //const [showPopUp, setShowPopUp] = useState(true);
  const [footerCounts, setFooterCounts] = useState({});
  //const [nextPrePage, setNextPrePage] = useState(1);
  const ref = useRef();

  const tableOneFetchOrders = (limit, sortby, feild, search) => {
    ref.current.tableOneFetchOrders(limit, sortby, feild, search);
  }

  const footerpageNum = (num) => {
    ref.current.pageNumber(num)
  }

  const tableOneRefresh = () => {
    ref.current.tableOneRefresh()
  }



  return (
    <div id="container" className="container">

      {spinner && <Spinner />}
      {/* <LeftMenuArea>
      <HomeLogoSection />
      <MenuSection>
        <HomeMenuSection />
        <ShortcutMenuSection />
        <ProductsMenuSection />
      </MenuSection>
    </LeftMenuArea> */}


      {/* <Content /> */}

      <MiddleSection>
        <ContentContainer>
          <SearchBarMenuItems tableOneFetchOrders={tableOneFetchOrders} tableOneRefresh={tableOneRefresh} updateIsLoggedIn={props.updateIsLoggedIn} showHideModal={setShowTableOneModal} />
          {/* <MessageBoxActionBtn /> */}
          {/* <SummaryCards /> */}
          {/* <TableSortingMenuActionBtn /> */}
          <TableOne footerCounts={setFooterCounts} updateIsLoggedIn={props.updateIsLoggedIn} spinner={setSpinner} tableOneEvent={setTableOneEvent} showHideModal={setShowTableOneModal} ref={ref} />

          {showTableOneModal && <TableOneEditModal spinner={setSpinner} tableOneRefresh={tableOneRefresh} resetTableOneEvent={setTableOneEvent} tableOneEvent={tableOneEvent} showHideModal={setShowTableOneModal} />}
          <TableFooter footerCounts={footerCounts} pageNumber={footerpageNum} />
        </ContentContainer>
        

      </MiddleSection>

      {/* <RightAddBar /> */}
      {/* <RightAddSection /> */}
        
    </div>)
  
}

export default Home